import FundPersonEntry from '@/app/modules/fund/components/fund-person-entry/fund-person-entry.vue';

export default {
  name: 'fund-edit-member-modal',
  components: {
    FundPersonEntry,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
  },
  methods: {
    dismiss() {
      this.$emit('close');
    },
    handleEditPerson(person) {
      this.$emit('close');

      const members = [...this.fund.members];
      const memberIdx = members.findIndex(member => member.uuid === person.uuid);
      if (memberIdx >= 0) {
        members.splice(memberIdx, 1, person);
        this.$store.dispatch('fund/updateFundMembers', members);
      }

      const updatedTrustee = {
        ...this.fund.trustee,
        trustees: [
          ...this.fund.trustee.trustees,
        ],
      };
      const trusteeIdx = updatedTrustee.trustees.findIndex(trustee => trustee.uuid === person.uuid);

      if (trusteeIdx >= 0) {
        updatedTrustee.trustees.splice(trusteeIdx, 1, person);
        this.$store.dispatch('fund/updateFundTrustee', updatedTrustee);
      }
    },
  },
};
